import { useEffect } from 'react';
import { UntrustedDataMembers } from '@auth0/auth0-acul-js';

import { isCreateOrganization, isNewAuthUser, isUserInvited } from '@page/auth/services/extraAuthParams';
import { useIsCreateOrgStorage } from '@page/core/hooks/onboarding/useIsCreateOrgStorage';
import { useIsNewUserStorage } from '@page/core/hooks/onboarding/useIsNewUserStorage';
import { useIsUserInvitedStorage } from '@page/core/hooks/onboarding/useIsUserInvitedStorage';

export const useExtraAuthParams = (untrustedData: UntrustedDataMembers) => {
  const _isNewUser = isNewAuthUser(untrustedData);
  const [isNewUserFromStorage, setIsNewUserFromStorage] = useIsNewUserStorage();

  useEffect(() => {
    setIsNewUserFromStorage(_isNewUser);
  }, [_isNewUser, setIsNewUserFromStorage]);

  const _isCreateOrganization = isCreateOrganization(untrustedData);
  const [isCreateOrgFromStorage, setIsCreateOrgFromStorage] = useIsCreateOrgStorage();

  useEffect(() => {
    setIsCreateOrgFromStorage(_isCreateOrganization);
  }, [_isCreateOrganization, setIsCreateOrgFromStorage]);

  const _isUserInvited = isUserInvited(untrustedData);
  const [isUserInvitedFromStorage, setIsUserInvitedFromStorage] = useIsUserInvitedStorage();

  useEffect(() => {
    setIsUserInvitedFromStorage(_isUserInvited);
  }, [_isUserInvited, setIsUserInvitedFromStorage]);

  return {
    isNewUser: _isNewUser || !!isNewUserFromStorage,
    isCreateOrg: _isCreateOrganization || !!isCreateOrgFromStorage,
    isUserInvited: _isUserInvited || !!isUserInvitedFromStorage,
  };
};
